<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-27 14:53:28
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="800"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<!-- 弹窗内容部分 -->
				<el-form :model="formData" ref="form" :label-width="labelWidth">
					<el-form-item>
						<div slot="label">
							<span class="yx-color-danger mr-4">*</span>
							<span>{{ configObj.label1 }}</span>
						</div>
						<el-input v-model="formData.title" :placeholder="configObj.placeholder" :maxlength="configObj.maxlength" show-word-limit />
					</el-form-item>
					<el-form-item>
						<div slot="label">
							<span class="yx-color-danger mr-4">*</span>
							<span>{{ configObj.label2 }}</span>
						</div>
						<div class="flex flex-align-end">
							<uploadImg
								:key="visible"
								@saveCardLink="saveCardLink"
								:limitSize="configObj.limitSize"
								:default_img="formData.imageUrl"
								:widthAndHeight="configObj.widthAndHeight"
								ref="uploadImg"
								class="upload-img"
							></uploadImg>
							<p class="yx-color-blue-6 ml-10 font-h6-regular">{{ configObj.uploadTips }}</p>
						</div>
					</el-form-item>
					<el-form-item>
						<div slot="label">
							<span class="yx-color-danger mr-4" v-if="type === 'jg'">*</span>
							<span>跳转类型</span>
						</div>
						<div class="flex flex-align-center">
							<p style="width: 130px" class="yx-color-text-p-4">
								<el-radio v-model="formData.linkType" class="yx-color-text-p-4" label="1">商品详情</el-radio>
							</p>
							<el-button type="primary" @click="addGoods" :disabled="formData.linkType !== '1'" plain>选择商品</el-button>
							<p class="flex flex-align-center ml-24" v-if="formData.product_id">
								<el-tooltip placement="top" :content="formData.product_name" v-ak-tooltip-auto-show>
									<span :class="['line-ellipsis-1 mr-18', formData.linkType !== '1' ? 'disable-style' : 'yx-color-pure-1']" style="max-width: 360px">
										已选：{{ formData.product_name }}
									</span>
								</el-tooltip>
								<el-button type="text" :disabled="formData.linkType !== '1'" @click="openPreview('productId')">预览</el-button>
							</p>
						</div>
						<div class="mt-24">
							<div class="flex">
								<p style="width: 130px" class="yx-color-text-p-4">
									<el-radio v-model="formData.linkType" label="2">活动集合页</el-radio>
								</p>
								<div>
									<div class="flex">
										<el-button type="primary" @click="addCollection" :disabled="formData.linkType !== '2'" plain>选择集合页</el-button>
										<p class="flex flex-align-center ml-24" v-if="formData.gatherId">
											<el-tooltip placement="top" :content="formData.bannerTitle" v-ak-tooltip-auto-show>
												<span
													:class="['line-ellipsis-1 mr-18', formData.linkType !== '2' ? 'disable-style' : 'yx-color-pure-1']"
													style="max-width: 330px"
												>
													已选：{{ formData.bannerTitle }}
												</span>
											</el-tooltip>
											<el-button type="text" :disabled="formData.linkType !== '2'" @click="openPreview('gatherId')">预览</el-button>
										</p>
									</div>

									<p class="font-h6-regular yx-color-blue-6 mt-12" v-if="formData.linkType === '2'">
										<i class="el-icon-info"></i>
										<span class="ml-4">若未找到您可</span>
										<span class="ml-4 yx-color-primary cursor-pointer" @click="createCollection">新建集合页</span>
									</p>
								</div>
							</div>
						</div>
						<div class="mt-24">
							<p style="width: 130px" class="yx-color-text-p-4">
								<el-radio v-model="formData.linkType" label="3">小程序</el-radio>
							</p>
							<div class="mt-12 ml-24" v-if="formData.linkType === '3'">
								<p><el-input v-model="formData.linkUrlAppid" style="width: 240px" placeholder="请输入小程序appid"></el-input></p>
								<p class="mt-8"><el-input v-model="formData.linkUrl" style="width: 240px" placeholder="请输入跳转页面"></el-input></p>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading" :disabled="!isDisable">确认</el-button>
			</div>
		</el-drawer>

		<!-- 添加商品 -->
		<addGoodsDrawer ref="addGoodsDrawer" :platformId="platformId" @confirmAddGoods="confirmAddGoods" />

		<!-- 选择集合页 -->
		<selectCollectionDrawer ref="selectCollectionDrawer" :platformId="platformId" @confirmAddCollection="confirmAddCollection" />

		<!-- 添加集合页 -->
		<addCollectionDrawer ref="addCollectionDrawer" :platformId="platformId" :size="640" />

		<!-- 预览 -->
		<previewDialog ref="previewDialog" />
	</div>
</template>
<script>
import previewDialog from '../previewDialog';
import addGoodsDrawer from '@/components/business/addGoodsDrawer';
import selectCollectionDrawer from '../selectCollectionDrawer';
import addCollectionDrawer from '../addCollectionDrawer';
import uploadImg from '@/components/common/uploadImg';
import { bannerAdd, iconsAdd, updateIcons, bannerUpdate } from '@/api/selectionDecoration';
export default {
	components: {
		addGoodsDrawer,
		previewDialog,
		selectCollectionDrawer,
		addCollectionDrawer,
		uploadImg,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	data() {
		return {
			visible: false, // 弹窗显隐
			formData: {
				title: '',
				imageUrl: '',
				linkType: '1',
				link: '',
				product_name: '',
				product_id: '',
				bannerTitle: '',
				gatherId: '',
				id: '',
				linkUrlAppid: '',
				linkUrl: '',
			}, // 表单数据
			loading: false, // 按钮loading状态
			type: 'banner',
			editType: 'add',
		};
	},
	computed: {
		title({ type }) {
			const obj = {
				banner: 'banner配置',
				jg: '金刚位配置',
			};
			return obj[type];
		},
		configObj({ type }) {
			const obj = {
				banner: {
					label1: 'banner标题',
					placeholder: '请输入最多30字',
					maxlength: '30',
					label2: 'banner图',
					uploadTips: '请上传JPG/PNG 格式的图片，尺寸 1053 * 600，大小不超过2M',
					limitSize: 2,
					widthAndHeight: [1053, 600],
				},
				jg: {
					label1: 'icon标题',
					label2: 'icon图',
					placeholder: '请输入最多4字',
					maxlength: '4',
					uploadTips: '请上传JPG/PNG 格式的图片，比例 144 * 144，大小不超过200kb',
					widthAndHeight: [144, 144],
					limitSize: 200 / 1024,
				},
			};
			return obj[type];
		},
		isDisable({ formData, type }) {
			const check1 = formData.linkType === '1' && formData.product_id;
			const check2 = formData.linkType === '2' && formData.gatherId;
			const check3 = formData.linkType === '3' && formData.linkUrlAppid;
			const jgCheck = type === 'jg' ? check1 || check2 || check3 : true;
			return formData.title && formData.imageUrl && jgCheck;
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(type = 'banner', val = {}) {
			console.log('val', val);

			if (val.id) {
				this.editType = 'edit';
				Object.keys(val).forEach(key => (this.formData[key] = val[key]));
				if (val.linkType === '1') {
					this.formData['product_id'] = val.link;
					this.formData['product_name'] = val.linkName;
				}
				if (val.linkType === '2') {
					this.formData['gatherId'] = val.link;
					this.formData['bannerTitle'] = val.linkName;
				}
			}
			this.type = type;
			this.visible = true;
		},
		addGoods() {
			this.$refs.addGoodsDrawer.show(this.formData.product_id);
		},
		addCollection() {
			const gatherId = this.formData.gatherId;
			this.$refs.selectCollectionDrawer.show(gatherId);
		},
		confirmAddGoods(val) {
			Object.keys(val).forEach(key => (this.formData[key] = val[key]));
		},
		confirmAddCollection(val) {
			Object.keys(val).forEach(key => (this.formData[key] = val[key]));
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.formData = {
				title: '',
				imageUrl: '',
				linkType: '1',
				link: '',
				product_name: '',
				product_id: '',
				bannerTitle: '',
				gatherId: '',
				id: '',
				linkUrlAppid: '',
				linkUrl: '',
			};
			this.editType = 'add';
			this.type = 'banner';
			this.loading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		async confirm() {
			const { type, platformId, editType } = this;
			const { title, linkType, product_id, gatherId, imageUrl, id, linkUrlAppid, linkUrl } = this.formData;
			const link = {
				1: product_id,
				2: gatherId,
				3: linkUrlAppid,
			};
			const api = {
				banner: editType === 'add' ? bannerAdd : bannerUpdate,
				jg: editType === 'add' ? iconsAdd : updateIcons,
			};
			const params = {
				banner: {
					platformId,
					title,
					linkType: link[linkType] ? linkType : '0',
					imageUrl,
					link: linkType !== '3' ? link[linkType] : '',
					id: editType === 'add' ? undefined : id,
					linkUrlAppid,
					linkUrl,
				},
				jg: {
					platformId,
					title,
					linkType,
					imageUrl,
					link: linkType !== '3' ? link[linkType] : '',
					tplType: 2,
					id: editType === 'add' ? undefined : id,
					linkUrlAppid,
					linkUrl,
				},
			};
			try {
				await api[type](params[type]);
				this.$message.success(`${editType === 'add' ? '添加' : '编辑'}成功`);
				// 按钮loading开启
				this.loading = false;
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 表单项标签宽度
			this.labelWidth = '100px';
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		createCollection() {
			this.$refs.addCollectionDrawer.show();
		},
		saveCardLink(val) {
			this.formData.imageUrl = val;
		},
		openPreview(key) {
			const { platformId, formData } = this;
			const obj = {
				productId: formData.product_id,
				gatherId: formData.gatherId,
			};
			this.$refs.previewDialog.show({ preview: 'preview_goods', platformId, link: obj[key], linkType: formData.linkType });
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.disable-style {
		color: #c9cdd4;
	}
	::v-deep .el-form-item {
		margin-bottom: 24px;
	}
	::v-deep .el-radio__label {
		color: #4e596a;
	}
	.upload-img {
		/deep/ .el-upload--picture-card {
			background-color: #fff;
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload-list--picture-card .el-upload-list__item {
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload--picture-card i {
			font-size: 16px;
			color: #86909d;
		}
	}
}
</style>
